import { Col, Form, Row } from "react-bootstrap";

const ForthStepMobile = ({forthStep, updateMultipleValues}) => {

    const handleChangeRadio = (e) => {
        const values = {...forthStep};
        values[e.target.id] = parseInt(e.target.value);
        updateMultipleValues({forthStep: values});
    }
    return (
      <>
        <div className="d-flex flex-column  position-relative"  onChange={(e) => handleChangeRadio(e)}>
        
            <h1 className="register-text" style={{fontSize: 24, marginBottom: 15}}>Teacher(s)</h1>
            {/* <div className="d-flex  align-items-end"> */}
            <Row style={{background: "rgba(217, 217, 217, 1)", color: "black", marginRight: 0, marginLeft: 0}}>
                <Col xs={3}><div className="form-label-mobile" style={{textAlign: "center"}}>Strongly disagree</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Disagree</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Neutral</div>
                </Col>
                <Col xs={2}><div className="form-label-mobile" style={{textAlign: "center"}}>Agree</div>
                </Col>
                <Col xs={3}><div className="form-label-mobile" style={{textAlign: "center"}}>Strongly agree</div>
                </Col>
            </Row>
            <Form>
                <Form.Group>
                    <Row style={{marginTop: 20, marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`teacher_approachability`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_approachability === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`teacher_approachability`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_approachability === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`teacher_approachability`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_approachability === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`teacher_approachability`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_approachability === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`teacher_approachability`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_approachability === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The teacher(s) of the course was/were approachable *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`teacher_contact_moments`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_contact_moments === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`teacher_contact_moments`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_contact_moments === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`teacher_contact_moments`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_contact_moments === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`teacher_contact_moments`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_contact_moments === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`teacher_contact_moments`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_contact_moments === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >There were enough contact moments with the teacher(s) (office hours, lectures) *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`teacher_discussion_opportunities`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_discussion_opportunities === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`teacher_discussion_opportunities`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_discussion_opportunities === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`teacher_discussion_opportunities`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_discussion_opportunities === 3} 
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`teacher_discussion_opportunities`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_discussion_opportunities === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`teacher_discussion_opportunities`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_discussion_opportunities === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The teacher(s) provided opportunities to discuss difficulties / questions *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`teacher_specific_needs`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_specific_needs === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`teacher_specific_needs`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_specific_needs === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`teacher_specific_needs`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_specific_needs === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`teacher_specific_needs`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_specific_needs === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`teacher_specific_needs`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_specific_needs === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The teacher(s) was able to deal with specific needs I had as an exchange student *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`teacher_motivating_manner`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_motivating_manner === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`teacher_motivating_manner`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_motivating_manner === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`teacher_motivating_manner`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_motivating_manner === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`teacher_motivating_manner`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_motivating_manner === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`teacher_motivating_manner`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_motivating_manner === 5} 
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}} >The teacher(s) taught in a motivating manner *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row style={{marginRight: 0, marginLeft: 0}}>
                    
                        
                        
                        <Col xs={3}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`teacher_international_perspective`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_international_perspective === 1}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`teacher_international_perspective`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_international_perspective === 2}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`teacher_international_perspective`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_international_perspective === 3}
                                />
                        </Col>
                        <Col xs={2}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`teacher_international_perspective`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_international_perspective === 4}
                                />
                        </Col>
                        <Col xs={3}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`teacher_international_perspective`}
                                    name="group6"
                                    style={{fontSize: 16}}
                                    checked={forthStep?.teacher_international_perspective === 5}
                                />
                        </Col>

                        <Col xs={12} style={{marginTop: 10}}><div className="form-label-mobile" style={{textAlign: "center"}}>The teacher(s) showed interest in international perspectives *</div>
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
      </div>
      </>
    );
  };
  
  export default ForthStepMobile;
  